<template>
  <section>
    <!-- Add message box -->
    <div class="add-message"
         @keyup.enter.exact="sendMessage">
      <message-textarea ref="messageEditor"
                        class="message-editor is-flex"
                        placeholder="Type a message..."
                        v-model="message"
                        :maxLength="maxLength"
                        @input="onChange" :chat="true" />
      <div class="message-options is-flex gtm-msg-send">
        <button class="send-button button is-primary gtm-msg-send"
                :disabled="!canSendMessage"
                @click="sendMessage">
          {{ $t('messaging.send') }}
        </button>
      </div>
    </div>
        <div v-if="error"
             class="help has-text-danger is-size-7">
          {{error}}
        </div>
  </section>
</template>

<script>
import MessageTextarea from '@/components/Inputs/QuillEditor'

import auth from '@/mixins/auth'

import debounce from 'lodash/debounce'

export default {
  props: ['conversation', 'chatType'],
  components: {
    MessageTextarea
  },
  mixins: [auth],
  data: function () {
    return {
      message: '',
      hasNonCharContent: false,
      maxLength: 2000,
      messageLength: 0,
      sending: false,
      error: '',
      hasProfanity: false
    }
  },
  computed: {
    hasContent: function () {
      return this.messageLength > 0 || this.hasNonCharContent
    },
    hasValidText: function () {
      return this.hasContent && this.messageLength < this.maxLength
    },
    canSendMessage: function () {
      return !this.sending && this.hasValidText
    }
  },
  methods: {
    setContents: function (value) {
      this.$refs.messageEditor.setContents(value)
    },

    sendMessage: debounce(function () {
      if (!this.canSendMessage) {
        return
      }
      if (this.hasProfanity) {
        this.error = this.hasProfanity
        return this.error
      }
      document.activeElement.blur()
      if (!this.isLoggedIn) {
        this.$store.dispatch('showLoginModal', { source: 'SENDMESSAGE', onSuccess: this.sendMessageLoggedIn, signupMessage: 'Sign up to send a message to the community' })
      } else {
        this.sendMessageLoggedIn()
      }
    }, 500, { leading: true, trailing: false }),
    sendMessageLoggedIn: function () {
      if ((this.messageLength === 0 && !this.hasNonCharContent) || this.messageLength > 2000) {
        return
      }

      this.error = ''

      if (this.conversation.draft) {
        const users = this.conversation.users.map((u) => { return u.userName })
        this.sending = true
        this.$store.dispatch('createConversation', users).then((conversation) => {
          this.conversation.id = conversation.id
          this.$emit('showConvo', conversation)
          this.sendMessageLoggedIn()
        }, (error) => {
          this.sending = false
          this.error = error.message
        })
        return
      }
      this.sending = true
      const params = { id: this.conversation.id, message: this.message, chatType: this.chatType }
      this.$store.dispatch('sendMessage', params).then(() => {
        this.$refs.messageEditor.setContents('')
        this.sending = false
        this.$emit('scrollToBottom')
      }, (error) => {
        this.sending = false
        this.error = error.message
      })
    },
    onChange: function (text) {
      this.messageLength = this.$refs.messageEditor.quillText ? this.$refs.messageEditor.quillText.trim().length : 0
      this.hasNonCharContent = this.$refs.messageEditor.hasNonCharContent
      this.hasProfanity = this.$refs.messageEditor?.hasProfanity()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
// ADD MESSAGE (QUILL EDITOR) STYLES
.add-message {
  background-color: white;
  flex: 1 0 auto;
  position: relative;
  @include mobile {
    width: 100%;
    background-color: whitesmoke;
  }
  @include touch{
    @include fix-ios-scrolling;
  }
  .message-editor {
    height: 100%;
    flex-direction: column;
    height: auto;
  }
  .message-options {
    justify-content: center;
    align-items: flex-end;
    border: none;
    flex-direction: column;
    margin: 0 0.6rem 0 0.6rem;
    min-width: 20%;
    position: absolute;
    bottom: 1px;
    right: 1px;
    width: 10rem;
    height: 2.95rem;
    .send-button {
      -webkit-appearance: none;
      border-radius: 0;
      width: 100%;
      max-width: 150px
    }
    @include mobile {
      .send-button {
        height: auto;
        width: auto;
        font-weight: 300;
        padding: 0.2rem 0.8rem;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.95rem;
        letter-spacing: 0.2px;
      }
    }
  }
}
  .help {
    right: 180px;
    position: absolute;
    bottom: 10px;
}
</style>
